import createDocumentResource from '../shared/createDocumentResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import { Rule } from './rulesResource';

const ruleRevision = createDocumentResource<Rule>({
  name: 'ruleRevision',
  endpoint: 'v1/orgs/:orgId/rule-revisions/:revisionId',
  type: Rule,
  observerCreator: emptyObserverCreator,
});

export default ruleRevision;
